module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.rootClass || ''
  }, [_c('div', {
    staticClass: "col-header-title"
  }, [_vm._v(_vm._s(_vm.header.text))]), _vm._v(" "), (_vm.header.legendText) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('span', _vm._g({}, on), [_c('v-icon', {
          attrs: {
            "small": "",
            "color": _vm.iconColor || ''
          }
        }, [_vm._v("mdi-information-outline")])], 1)]
      }
    }], null, false, 1668216842)
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.header.legendText))])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66f2c538"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/LegendIcon.vue
// module id = 2164
// module chunks = 0